export { useCategoryStore };
import { defineStore } from 'pinia';
import { kyWithAuth } from '../libs/ky';

const initialState = () => ({
  categories: [],
  loading: false,
  lastFetched: null
});

const useCategoryStore = defineStore('categories', {
  state: initialState,
  getters: {
    shouldRefetch() {
      // Recharger si jamais chargé ou si dernière charge il y a plus de 2 minutes
      if (!this.lastFetched) return true;
      const twoMinutesAgo = new Date(Date.now() - 2 * 60 * 1000);
      return this.lastFetched < twoMinutesAgo;
    }
  },
  actions: {
    async fetchCategories(forceRefresh = false) {
      if (this.loading) return this.categories;
      if (!forceRefresh && !this.shouldRefetch) return this.categories;

      this.loading = true;
      try {
        const { categories = [] } = await kyWithAuth.get('categories').json();
        this.categories = categories;
        this.lastFetched = new Date();
        return categories;
      } catch (error) {
        console.error('Error fetching categories:', error);
        // Ensure state is clean on error too, or revert to previous state if preferred
        this.categories = [];
        this.lastFetched = null;
      } finally {
        this.loading = false;
      }
    },
    // async fetchCategory(categoryName) { // This action is likely no longer needed or its purpose needs to be re-evaluated
    //   const { category } = await kyWithAuth.get(`categories/${categoryName}`).json();
    //   return category;
    // }
    reset() {
      // Reset the store to its initial state
      const s = initialState();
      this.categories = s.categories;
      this.loading = s.loading;
      this.lastFetched = s.lastFetched;
      console.log('Category store has been reset.');
    }
  }
});
